import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "../TypeBoxToType";

export const InteractiveChannelType = Type.Union([Type.Literal("whatsapp"), Type.Literal("twilio"), Type.Literal("imessage")]);
export type InteractiveChannelType = TypeBoxToType<typeof InteractiveChannelType>;

export const ChannelType = Type.Union([
  Type.Literal("whatsapp"),
  Type.Literal("twilio"),
  Type.Literal("imessage"),
  Type.Literal("teams-archive"),
  Type.Literal("discord-archive"),
]);
export type ChannelType = TypeBoxToType<typeof ChannelType>;

export function isInteractiveChannel(type: ChannelType): type is InteractiveChannelType {
  return type === "whatsapp" || type === "twilio" || type === "imessage";
}

export const CHANNEL_INFO: Record<ChannelType, { name: string; icon?: string }> = {
  whatsapp: { name: "WhatsApp", icon: "https://public-whatslly.s3.us-west-2.amazonaws.com/channels/icons/WhatsApp.svg.webp" },
  twilio: { name: "SMS" },
  imessage: { name: "iMessage" },
  "teams-archive": { name: "Teams Archive" },
  "discord-archive": { name: "Discord Archive" },
};

export const getChannelInfo = (channelType: ChannelType) => {
  return CHANNEL_INFO[channelType];
};
